export const ApiQueryKey = {
	me: 'auth/me',

	companies: 'companies',
	addresses: 'addresses',

	admins: 'admins',
	clients: 'clients',
	contacts: 'contacts',
	clientGroups: 'client-groups',
	loginHistory: 'logins-history',

	contents: 'contents',
	products: 'products',

	productTypeCategories: 'product-type-categories',
	productTypes: 'product-types',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	productModels: 'product-models',
	orders: 'orders',
	shippingMethods: 'shipping-methods',
	shippingPriorities: 'shipping-priorities',
	roles: 'roles',
	reviews: 'reviews',
	packages: 'packages',
	payments: 'payments',
	clientPackages: 'client-packages',
	transactions: "transactions",
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
